import Parse from "parse";

import type { _User } from "./_User";
import type { SIV_GoodsReceiptProcessPosition } from "./SIV_GoodsReceiptProcessPosition";
import type { SIV_GoodsReceiving } from "./SIV_GoodsReceiving";
import type { SIV_Order } from "./SIV_Order";
import type { OD3_Tenant } from "./OD3_Tenant";

export interface SIV_GoodsReceiptProcessPositionGoodsReceivingAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;
  changedBy?: _User | undefined;
  date?: Date | undefined;
  goodsReceiptProcessPosition: SIV_GoodsReceiptProcessPosition;
  goodsReceiving?: SIV_GoodsReceiving | undefined;
  internalNo: number;
  notFoundValues: any;
  order: SIV_Order;
  quantity?: number | undefined;
  tenant: OD3_Tenant;
  weight?: number | undefined;
}

export class SIV_GoodsReceiptProcessPositionGoodsReceiving extends Parse.Object<SIV_GoodsReceiptProcessPositionGoodsReceivingAttributes> {
  static className: string = "SIV_GoodsReceiptProcessPositionGoodsReceiving";

  constructor(
    data?: Partial<SIV_GoodsReceiptProcessPositionGoodsReceivingAttributes>,
  ) {
    super(
      "SIV_GoodsReceiptProcessPositionGoodsReceiving",
      data as SIV_GoodsReceiptProcessPositionGoodsReceivingAttributes,
    );
  }

  get changedBy(): _User | undefined {
    return super.get("changedBy");
  }
  set changedBy(value: _User | undefined) {
    super.set("changedBy", value);
  }

  get date(): Date | undefined {
    return super.get("date");
  }
  set date(value: Date | undefined) {
    super.set("date", value);
  }

  get goodsReceiptProcessPosition(): SIV_GoodsReceiptProcessPosition {
    return super.get("goodsReceiptProcessPosition");
  }
  set goodsReceiptProcessPosition(value: SIV_GoodsReceiptProcessPosition) {
    super.set("goodsReceiptProcessPosition", value);
  }

  get goodsReceiving(): SIV_GoodsReceiving | undefined {
    return super.get("goodsReceiving");
  }
  set goodsReceiving(value: SIV_GoodsReceiving | undefined) {
    super.set("goodsReceiving", value);
  }

  get internalNo(): number {
    return super.get("internalNo");
  }
  set internalNo(value: number) {
    super.set("internalNo", value);
  }

  get notFoundValues(): any {
    return super.get("notFoundValues");
  }
  set notFoundValues(value: any) {
    super.set("notFoundValues", value);
  }

  get order(): SIV_Order {
    return super.get("order");
  }
  set order(value: SIV_Order) {
    super.set("order", value);
  }

  get quantity(): number | undefined {
    return super.get("quantity");
  }
  set quantity(value: number | undefined) {
    super.set("quantity", value);
  }

  get tenant(): OD3_Tenant {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant) {
    super.set("tenant", value);
  }

  get weight(): number | undefined {
    return super.get("weight");
  }
  set weight(value: number | undefined) {
    super.set("weight", value);
  }
}

Parse.Object.registerSubclass(
  "SIV_GoodsReceiptProcessPositionGoodsReceiving",
  SIV_GoodsReceiptProcessPositionGoodsReceiving,
);
